/* Preserve only explicit legacy Playsets campaign entry links. */
(() => {
  'use strict';
  const config=JSON.parse(document.querySelector('[data-playsets-routing]')?.textContent||'null');
  if(!config||Number(window.Shopify?.theme?.id)!==config.themeId)return;
  const playsets={
    "subway-sandwich-artist-53-piece-playset": "subway",
    "spider-man-tool-bench-playset-with-take-apart-car-55-pieces-main": "spider-man",
    "spidey-and-his-amazing-friends-tool-bench-playset-55-pieces": "spidey",
    "nascar-work-bench-playset": "nascar",
    "big-boys-tool-and-bench-playset": "big-boys"
};
  function destination(source,ready=config.masterPublic){
    const url=new URL(source,location.origin),view=url.searchParams.get('view');
    if(url.pathname!=='/collections/playsets'||view!=='hobbytron-playsets')return null;
    const playset=playsets[url.searchParams.get('product')];
    if(!playset)return null;
    url.pathname=ready?'/products/ultimate-adventure-playsets':'/collections/playsets';url.searchParams.set('playset',playset);
    for(const p of ['product','variant','view'])url.searchParams.delete(p);
    if(!ready)url.searchParams.set('view','hobbytron-playsets-master');
    const previewTheme=new URL(location.href).searchParams.get('preview_theme_id');if(previewTheme)url.searchParams.set('preview_theme_id',previewTheme);else url.searchParams.delete('preview_theme_id');return url.href;
  }
  window.PlaysetsMasterRoutes=Object.freeze({destination});
  const redirect=destination(location.href);if(redirect){location.replace(redirect);return;}
})();
